import styled, { css } from "styled-components";

export const HomeLayoutWrapper = styled.main`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: salmon;
  display: flex;
`;

export const HomeSidebarWrapper = styled.div`
  width: 4.5rem;
  height: auto;
  background: #181818;
`;

export const HomeBoardWrapper = styled.div`
  flex: 1;
  height: auto;
  background: #212225;
  position: relative;
`;

interface HomeBoardGridProps {
  loading?: number;
}

export const HomeBoardGrid = styled.div<HomeBoardGridProps>`
  width: 100%;
  height: 100%;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  transform: rotate(180deg);
  z-index: 1;

  ${(props) =>
    props.loading !== 1 &&
    css`
      pointer-events: none;
    `}

  & > div {
    flex-basis: 25%;
    height: 100%;
    position: relative;

    ${(props) =>
      props.loading === 0 &&
      css`
        border-right: 1px solid rgba(193, 193, 193, 0.03);
      `}

    &:last-child {
      border: none;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: ${(props) => (props.loading === 1 ? "100%" : "0%")};
      height: 100%;
      background: #181818;
      transition: width 1s ease;
      z-index: ${(props) => (props.loading === 1 ? "1000" : "-1")};
    }
  }
`;

export const HomeBoardContent = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
`;
